module.exports = __webpack_public_path__ + "img/8fa2602c00362279ae712ba2da4dcf78.png";